import React, { useState } from "react";
import cx from "classnames";
import { ExternalLinkIcon } from "assets";
import { ImageLocation } from "models";
import FullScreenMediaViewer from "pages/Profile/components/common/FullScreenMediaViewer";
import IProfileViewPhoto from "models/ProfileView/ProfileViewPhoto";
import ThumbnailButton from "pages/Profile/components/GallerySection/ThumbnailButton";
import SlideButton from "pages/Profile/components/common/SlideButton";
import ProfileButton from "pages/Profile/components/common/ProfileButton";
import { getImageUrl } from "services/UrlBuilder";

interface Props {
  toggleFullScreenViewer?: () => void;
  selectedIndex?: number;
  gallery: IProfileViewPhoto[];
}

const GalleryMediaViewer = ({
  toggleFullScreenViewer,
  selectedIndex = 0,
  gallery,
}: Props) => {
  const [currentIndex, setCurrentIndex] = useState(selectedIndex);
  const nextSlide = () =>
    setCurrentIndex((prev) => (prev + 1) % gallery.length);
  const prevSlide = () =>
    setCurrentIndex((prev) => (prev - 1 + gallery.length) % gallery.length);

  const selectedPhoto = gallery[currentIndex];
  const isNavVisible = gallery.length > 1;

  return (
    <FullScreenMediaViewer onToggle={toggleFullScreenViewer}>
      <div className="flex min-h-screen flex-col items-center justify-center p-4 sm:p-8">
        <div className="relative flex w-full max-w-4xl flex-col items-center">
          <div className="relative flex h-[70vh] w-full items-center justify-center overflow-hidden">
            <div className="relative m-auto flex h-full w-content">
              <img
                src={getImageUrl(selectedPhoto.url, ImageLocation.ViewPhoto)}
                alt={selectedPhoto.description}
                className="max-h-full max-w-full object-contain"
              />
              <ProfileButton
                onClick={() =>
                  window.open(
                    getImageUrl(selectedPhoto.url, ImageLocation.ViewPhoto),
                    "_blank"
                  )
                }
                className="absolute bottom-2 right-2 !bg-white text-color-brand-one"
              >
                <ExternalLinkIcon width={20} height={20} />
              </ProfileButton>
            </div>
            <SlideButton
              className={cx(
                "absolute left-4 bg-white/80 text-color-brand-one hover:bg-white/90",
                {
                  hidden: !isNavVisible,
                }
              )}
              direction="prev"
              onClick={prevSlide}
            />
            <SlideButton
              className={cx(
                "absolute right-4 bg-white/80 text-color-brand-one hover:bg-white/90",
                {
                  hidden: !isNavVisible,
                }
              )}
              direction="next"
              onClick={nextSlide}
            />
            <div className="absolute bottom-3 left-4 text-s text-white drop-shadow-profile">
              {selectedPhoto.photographer && `© ${selectedPhoto.photographer}`}
              {selectedPhoto.photographer && selectedPhoto.description && " - "}
              {selectedPhoto.description && `${selectedPhoto.description}`}
            </div>
          </div>

          <div className="no-scrollbar mt-6 flex flex-wrap gap-2">
            {gallery.map((photo, index) => {
              return (
                <ThumbnailButton
                  key={`photo-button-${index}`}
                  isSelected={index === currentIndex}
                  onClick={() => setCurrentIndex(index)}
                >
                  <img
                    src={getImageUrl(photo.url, ImageLocation.ViewPhoto)}
                    alt={photo?.description}
                    className={cx(
                      "block h-full w-full rounded-[10px] object-cover"
                    )}
                  />
                </ThumbnailButton>
              );
            })}
          </div>
        </div>
      </div>
    </FullScreenMediaViewer>
  );
};

export default GalleryMediaViewer;
